/**
 * @generated SignedSource<<0e235dffb6e940b11afae6e01d0fc9fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type unified_ingest_upload_complete_params = {
  file_id: string;
  owner_name: string;
};
export type useUnifiedIngestUploadCompleteQuery$variables = {
  params: unified_ingest_upload_complete_params;
};
export type useUnifiedIngestUploadCompleteQuery$data = {
  readonly unified_ingest_upload_complete: {
    readonly file_size: number;
    readonly owner_name: string;
    readonly upload_complete: boolean;
  };
};
export type useUnifiedIngestUploadCompleteQuery = {
  response: useUnifiedIngestUploadCompleteQuery$data;
  variables: useUnifiedIngestUploadCompleteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "params"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "params",
        "variableName": "params"
      }
    ],
    "concreteType": "unified_ingest_upload_complete_output",
    "kind": "LinkedField",
    "name": "unified_ingest_upload_complete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "owner_name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "upload_complete",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "file_size",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUnifiedIngestUploadCompleteQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUnifiedIngestUploadCompleteQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "568e76353fc3ef91067a3b59335eed13",
    "id": null,
    "metadata": {},
    "name": "useUnifiedIngestUploadCompleteQuery",
    "operationKind": "query",
    "text": "query useUnifiedIngestUploadCompleteQuery(\n  $params: unified_ingest_upload_complete_params!\n) {\n  unified_ingest_upload_complete(params: $params) {\n    owner_name\n    upload_complete\n    file_size\n  }\n}\n"
  }
};
})();

(node as any).hash = "58ab4836b2cad45352df903c133a508a";

export default node;
